import { render, staticRenderFns } from "./ClearanceStockBlock.vue?vue&type=template&id=65be59df"
import script from "./ClearanceStockBlock.vue?vue&type=script&lang=js"
export * from "./ClearanceStockBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports